const DojoTransactionResultStatus = Object.freeze({
    SUCCESSFUL: 'SUCCESSFUL',
    DECLINED: 'DECLINED',
    VOID: 'VOID',
    UNSUCCESSFUL: 'UNSUCCESSFUL',
    CANCELLED: 'CANCELLED',
    TIMED_OUT: 'TIMED_OUT',
});

module.exports = DojoTransactionResultStatus;
